import { render, staticRenderFns } from "./JustificationReasonEntryDialog.vue?vue&type=template&id=e6e4c95a&scoped=true"
import script from "./JustificationReasonEntryDialog.vue?vue&type=script&lang=js"
export * from "./JustificationReasonEntryDialog.vue?vue&type=script&lang=js"
import style0 from "./JustificationReasonEntryDialog.vue?vue&type=style&index=0&id=e6e4c95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e4c95a",
  null
  
)

export default component.exports